import { Close, Remove } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import type { ConnectionQualityState } from "../types/connectionQuality";
import { ChatSessionUser, UserRole } from "../types";
import ConnectionQualityIcon from "./ConnectionQualityIcon";

type ChatBrandInfoProps = {
  onMinimize?: () => void | undefined;
  onClose: () => void;
  user?: ChatSessionUser | null | undefined;
  connectionQuality?: ConnectionQualityState;
}
const ChatBrandInfo: React.FC<ChatBrandInfoProps> = ({ onMinimize, onClose, user, connectionQuality }) => {
  const userIdInfo = () => {
    if (user && user.role !== UserRole.Client && user.external_user_id) {
      return `- ${user.external_user_id}`;
    }
    return '';
  }
  return (<Box className="chatyme-brand-info" sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
    <Typography
      variant="subtitle1"
      className="chatyme-brand-info-text"
      sx={{
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 600,
        minWidth: 0,
        flex: 1
      }}
    >
      {process.env.REACT_APP_BRAND_NAME} {userIdInfo()}
    </Typography>
    <Box className="chatyme-brand-info-actions" sx={{ display: 'flex', alignItems: 'center' }}>
      {connectionQuality && <ConnectionQualityIcon state={connectionQuality} />}
      {onMinimize &&
        <IconButton onClick={onMinimize}>
          <Remove />
        </IconButton>
      }
      <IconButton onClick={onClose}>
        <Close />
      </IconButton>
    </Box>
  </Box>)
}

export default ChatBrandInfo;